export default function Stat_Correlation() {
  return <div>Stat_Correlation Component</div>;
}
